import '@backstage/ui/css/styles.css';
import '@backstage/cli/asset-types';
import { createRoot } from 'react-dom/client';
import app from './App';

createRoot(document.getElementById('root')!).render(app);
